var navigationPublic = {
    welcome:"Welcome",
    rewards:"Rewards",
    register:"Join Now",
    registerAgency:"Agency Registration",
    registerAgent:"Agent/Agency Register",
    login:"Login",
    lang:"Español",
    contact:"Contact Us"

}
module.exports = navigationPublic


